import { useTargetedModel } from '@cotera/client/v0/actions/framework';
import { WORKFLOW_RENDER_NODE_KEYS } from './workflow-render-catalog';
import type { WorkflowGraphNodeViewModelHandle } from './workflow-render-catalog/types';
import { WorkflowModel } from './workflow.model';
import type { WorkflowAgentNodeModel } from './workflow-node-models/workflow-agent-node.model';

export function useWorkflowAgentNodeModel(
  agentId: string | undefined
): WorkflowAgentNodeModel | null {
  const workflowModel = useTargetedModel(WorkflowModel);
  if (workflowModel === null || agentId === undefined || agentId === '') {
    return null;
  }
  return workflowModel.getRenderableNodeModel<WorkflowAgentNodeModel>(
    WORKFLOW_RENDER_NODE_KEYS.agent,
    agentId
  );
}

export function useWorkflowAgentNodeModelFromViewModel(
  viewModel: WorkflowGraphNodeViewModelHandle | null
): WorkflowAgentNodeModel | null {
  if (viewModel?.descriptorKey !== WORKFLOW_RENDER_NODE_KEYS.agent) {
    return null;
  }
  return viewModel.model as WorkflowAgentNodeModel;
}
